import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Scoreboard from "./components/Scoreboard";
import Schedule from "./components/Schedule";
import Reports from "./components/Reports";
import Bracket from "./components/Bracket";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Scoreboard />
        <Schedule />
        <Reports />
        <Bracket />
        <Faq />
        <About />
      </main>
      <Footer />
    </>
  );
}